import apiClient from "./apiClient";

const fetchUsers = async () => {
  const response = await apiClient.get("/users");
  return response.data._embedded.users;
};

const createUser = async (user) => {
  const response = await apiClient.post("/users", user);
  return response.data;
};

const authenticate = async (user) => {
  const response = await apiClient.post("users/authenticate", {
    username: user.username,
    password: user.password,
  });
  return response.data;
};

const fetchAuthenticatedUser = async (token) => {
  const response = await apiClient.get("/users/me", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const refreshAuthToken = async (param) => {
  const response = await apiClient.post(
    "users/refresh-token",
    {},
    {
      headers: { "X-Refresh-Token": param.refreshToken },
    }
  );
  return response.data;
};

const updateUser = async (user) => {
  const response = await apiClient.put("/users", user);
  return response.data;
};

const deleteUser = async (userId) => {
  const response = await apiClient.delete(`/users/${userId}`);
  return response.data;
};

const fetchUserById = async (userId) => {
  const response = await apiClient.get(`/users/${userId}?includeAllProps=true`);
  return response.data;
};

const fetchUserRoles = async () => {
  const response = await apiClient.get("/users/roles");

  return response.data;
};

const fetchUserDesignations = async () => {
  const response = await apiClient.get("/users/designations");

  return response.data._embedded.designations;
};

const verifyEmailAddress = async () => {
  const response = await apiClient.post("/email/send-verify");

  return response;
};

const resendVerifyEmailAddress = async (emailAddress) => {
  await apiClient.post(
    "/email/resend-verify",
    {},
    {
      params: {
        email: emailAddress,
      },
    }
  );
};

const sendUserInviteEmail = async (emailAddress) => {
  await apiClient.post(
    "/email/send-verify",
    {},
    {
      params: {
        email: emailAddress,
      },
    }
  );
};

const sendPasswordResetEmail = async (emailAddress) => {
  await apiClient.post(
    "/email/send-password-reset",
    {},
    {
      params: {
        email: emailAddress,
      },
    }
  );
};

const fetchUserCount = async () => {
  const response = await apiClient.get("/users?includeAllProps=false");
  return response.data.page.totalElements;
};

const fetchMetaUserCount = async (params) => {
  const response = await apiClient.get("/users?includeAllProps=false", {
    params: { ...params },
  });

  return response.data.page.totalElements;
};

const fetchUsersWithMetaParams = async (params) => {
  const response = await apiClient.get("/users?includeAllProps=false", {
    params: { ...params },
  });

  return response.data;
};

const getUserByUsername = async (username) => {
  const response = await apiClient.get(`/users?username=${username}`);
  return (
    response.data._embedded.users?.filter(
      (it, idx) => it.username === username
    )[0] || null
  );
};

export {
  fetchUsers,
  createUser,
  updateUser,
  deleteUser,
  fetchUserById,
  authenticate,
  fetchAuthenticatedUser,
  refreshAuthToken,
  fetchUserRoles,
  fetchUserDesignations,
  resendVerifyEmailAddress,
  verifyEmailAddress,
  sendUserInviteEmail,
  sendPasswordResetEmail,
  fetchUserCount,
  fetchMetaUserCount,
  fetchUsersWithMetaParams,
  getUserByUsername,
};
